import React, { Component } from 'react';

import { I18n } from 'components/translate';
import DateHelper, { shortFormatDate } from 'helpers/Date';
import { formatBytes } from 'helpers/File';
import PropTypes from 'prop-types';

import { UPLOAD_STATUS } from '../constants';

export default class FileSectionHeaderInfo extends Component {
  static propTypes = {
    id: PropTypes.string,
    name: PropTypes.string,
    size: PropTypes.number,
    creationDate: PropTypes.string,
    status: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  };

  get classNameDescription() {
    const { status = '' } = this.props;

    return `
      label__description 
      file__section__header__description 
      file__section__header__description--${status.toLowerCase()}
    `;
  }

  get hasFailed() {
    return this.props.status === UPLOAD_STATUS.FAILED;
  }

  render() {
    const { name } = this.props;

    return (
      <div className="file__section__header__content">
        <span className="file__section__header__title">{name}</span>
        <label className={this.classNameDescription}>
          {!this.hasFailed ? this.renderFileData() : this.renderFailed()}
        </label>
      </div>
    );
  }

  renderFailed() {
    return <I18n label="alerts.error" />;
  }

  renderFileData() {
    const { size, creationDate } = this.props;

    const formattedSize = formatBytes(size);
    const formattedDate = DateHelper.format(creationDate, shortFormatDate);
    const formattedTime = DateHelper.format(creationDate, 'HH:mm');

    return (
      <I18n
        label="files.upload_timestamp"
        data={{
          size: formattedSize,
          date: formattedDate,
          time: formattedTime
        }}
      />
    );
  }
}
